/*
var options = {
  method: 'GET',
  url: 'https://coinranking1.p.rapidapi.com/stats',
  headers: {
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '50c96595f7mshd4d525c95fa6941p175ea3jsn2043ac75fa79'
  }
}; */
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

const cryptoApiHeaders = {
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '50c96595f7mshd4d525c95fa6941p175ea3jsn2043ac75fa79'
}
const baseUrl= 'https://coinranking1.p.rapidapi.com';

const createRequest = (url) => ({url, headers: cryptoApiHeaders})

export const cryptoApi = createApi({
  reducerPath: 'cryptoApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCryptos: builder.query({
      query: (count) =>createRequest(`/coins?limit=${count}`) ,
    }),
     getExchanges: builder.query({
      query: () =>createRequest(`/exchanges`) ,
    }),
     getCryptoDetails: builder.query({
      query: (coinId) =>createRequest(`/coin/${coinId}`) ,
    }),
    getCryptoHistory: builder.query({
      query: ({coinId, timePeriod }) =>createRequest(`/coin/${coinId}/history/${timePeriod}`) ,
    }),
  }),
})

export const{
    useGetCryptosQuery,useGetCryptoDetailsQuery, useGetCryptoHistoryQuery, useGetExchangesQuery
} = cryptoApi;